const getElementSizes = (element) => {
  const { width, height } = element.getBoundingClientRect();

  return {
    width,
    height,
    aspectRatio: parseFloat((width / height).toFixed(4)),
  };
};

export default getElementSizes;
